import { get_STATS_URI_BASE ,getIsEdge } from "../../configs/env";
import {
    IKorraEvent,
    IKorraEventDoc,
    IKorraEventType,
} from "../../models/interfaces";
import logger from "../../logger";
import { getEdgeUserLoginSession} from "../../utils";
import { store } from "../../redux/store";

const axios = require("axios").default;

export const sendEvent = (
    workspaceId: string,
    kappId?: string,
    portalId?: string,
    portalAlias?: string,
    sessionId?: string,
    eventType?: IKorraEventType,
    userAgent?: string,
    platform?: string,
    userId?: string,
    eventDoc?: IKorraEventDoc,
    ip?: string,
    fingerprint?: string,
) => {
    try {
        const globals = store.getState().globals;
        const finalUserId = globals.customUserId ?? userId;
        let payload: any = {
            workspaceId,
            kappId,
            portalId,
            portalAlias,
            sessionId,
            eventType,
            userAgent,
            platform,
            userId: finalUserId,
            eventDoc,
            fingerprint,
        }
        if (getIsEdge()){
            const edgeUser = getEdgeUserLoginSession();
            const user_email = edgeUser?.user?.email
            payload = {
                ...payload,
                userId: user_email,
            };
        }
        axios.post(`${get_STATS_URI_BASE()}/stats/web-app`, payload, {
            headers: {
                "X-Client-IP": ip || "",
            },
        });
    } catch (event: any) {
        logger.error({
            message: "Failed to send event to stats service",
            error: event,
            stacktrace: event?.stack,
            workspace_id: workspaceId,
            portal_id: portalId,
            portal_alias: portalAlias,
            event_type: eventType,
            user_id: userId,
            error_detail: event?.message
        });
    }
};
